// src/routes/ProtectedRoute.jsx
import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedRoute = ({ children }) => {
  // 예시: localStorage에서 토큰 확인 (로그인 로직에 맞게 수정하세요)
  const isAuthenticated = localStorage.getItem('AccessToken'); 

  if (!isAuthenticated) {
    // 토큰이 없으면 로그인 페이지로 리다이렉트
    return <Navigate to="/login" replace />;
  }

  // 토큰이 있으면 자식 컴포넌트(MainPage)를 렌더링
  return children;
};

// 🌟 이 부분이 반드시 있어야 App.js에서 'default'로 불러올 수 있습니다.
export default ProtectedRoute;